import React from 'react';
export function LoadingAnimation() {
  return <div className="flex flex-col items-center gap-6" data-id="element-174">
      <div className="relative w-16 h-16" data-id="element-175">
        <div className="absolute inset-0 rounded-full border-4 border-gray-200 dark:border-gray-700" data-id="element-176" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-500 animate-spin" data-id="element-177" />
        <div className="absolute inset-2 rounded-full border-4 border-transparent border-t-purple-500 animate-spin" style={{
        animationDirection: 'reverse',
        animationDuration: '1s'
      }} data-id="element-178" />
      </div>
      <div className="text-sm font-medium text-gray-600 dark:text-gray-400" data-id="element-179">
        Cargando datos...
      </div>
    </div>;
}